import React, {useEffect, useState, useCallback} from 'react';
import {notification} from 'antd';
import AutoComplete from '@/components/AutoComplete/AutoComplete';
import {Settlement} from "@/types/types";
import catalogueService from "@/services/catalogueService";
import {renderSettlementType} from "@/common/common";
import {RegionOptions} from "@/store/types/RegionOptions";

type SettlementAutoCompletePropsType = {
    regionId?: number,
    value?: number,
    onChange?: (value?: number) => void
}
export const SettlementAutoComplete: React.FC<SettlementAutoCompletePropsType> = (props) => {
    const {regionId, value, onChange} = props;
    const [currentValue, setCurrentValue] = useState<RegionOptions>();
    
    const renderSettlementValue = (settlement: Settlement) => {
        const settlementCategory = renderSettlementType(settlement?.category);
        const districtName = settlement?.district?.name || '';
        const regionName = settlement?.district?.region?.name || '';
        const regionLabel = regionName
            ? ` (${regionName} обл.${districtName ? `, ${districtName} район` : ''})`
            : '';
        const settlementCategoryLabel = settlementCategory ? `${settlementCategory}` : '';
        return `${settlementCategoryLabel}${settlement.name}${regionLabel}`;
    };

    useEffect(() => {
        void init(value);
    }, [value]);
    
    const init = async (id?: number) => {
        if (!id) {
            setCurrentValue(undefined);
            return;
        }
        const  res = await catalogueService.getSettlementById(id);
        console.log("getSettlementById: ", res);
        setCurrentValue({label: renderSettlementValue(res), value: res.id})
    }
    
    const renderSettlementOption = (settlement: RegionOptions) => (
        <span key={settlement.value.toString()}>
            {settlement.label}
        </span>
    )
    
    const onChangeHandler = (val?: RegionOptions) => {
        setCurrentValue(val);
        onChange && onChange(val?.value);
    }

    const onSearchSettlements = useCallback(async (text: string) => {
        if (!text) {
            return undefined;
        }

        try {
            const res = await catalogueService.searchSettlements(text, regionId);
            return res.map(x => ({label: renderSettlementValue(x), value: x.id}))
        } catch (e) {
            console.log('error', e);
            notification.warning({
                message: 'Щось пішло не так ...',
                description: 'Спробуйте знову або зверніться до служби підтримки',
            });
        }
    }, [regionId]);
    
    return (
        <AutoComplete<RegionOptions>
            allowClear
            placeholder={'Виберіть регіон або місто'}
            onSearch={onSearchSettlements}
            labelExtractor={(e) => e.label}
            labelSearchExtractor={item => item.label}
            keyExtractor={item => item.value.toString()}
            renderOption={renderSettlementOption}
            //value={{label: `${value}`, value: value || 0}}
            value={currentValue}
            onChange={onChangeHandler}
        />
    );
}